import React from 'react';
import HouseDetailsHeroSection from "../Componentes/HouseDetails1/HouseDetailsHeroSection/HouseDetailsHeroSection";
import HouseDetailsGallery from "../Componentes/HouseDetails1/HouseDetailsGallery/HouseDetailsGallery";
import HouseDetailsBottom from "../Componentes/HouseDetails1/HouseDetailsBottom/HouseDetailsBottom";

const HouseDetails1 = () => {
	return (
		<>
			<HouseDetailsHeroSection />
			<HouseDetailsGallery />
			<HouseDetailsBottom />
		</>
	);
};

export default HouseDetails1;